import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getUsers = (token, page, search) => {
    return fetch(`${apiUrl}users?search=${search}&page=${page}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getUsers